<div class="dashboard-container">
    <div class="dashboard-cards">
        <mat-card class="dashboard-card" (click)="navigateToManageUserRequests()">
            <mat-icon class="dashboard-icon">assignment</mat-icon>
            <h2>Manage User Requests</h2>
            <p>Manage and Edit User Requests</p>
        </mat-card>

        <mat-card class="dashboard-card" (click)="navigateToManageResidents()">
            <mat-icon class="dashboard-icon">report</mat-icon>
            <h2>Manage Residents</h2>
            <p>Manage and Edit Resident Information</p>
        </mat-card>
    </div>
</div>
